var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffcanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 22.6663H6.66634M25.333 15.9997H6.66634M25.333 9.33301H14.6663",
    stroke: "url(#paint0_linear_193_43033)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_43033",
    x1: 15.9997,
    y1: 9.33301,
    x2: 15.9997,
    y2: 22.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30ECAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffcanvas);
export default __webpack_public_path__ + "static/media/offcanvas.4513e2435884c1e5f7a70c39894a3589.svg";
export { ForwardRef as ReactComponent };